export const portugueseFlashcards = {
  categories: [
    {
      pt: "Olá",
      rm: "O-lah",
      en: "Hello",
    },
    {
      pt: "Bom dia",
      rm: "Bon dee-ah",
      en: "Good morning",
    },
    {
      pt: "Boa tarde",
      rm: "Boa tar-deh",
      en: "Good afternoon",
    },
    {
      pt: "Boa noite",
      rm: "Boa noy-teh",
      en: "Good evening / Good night",
    },
    {
      pt: "Adeus",
      rm: "Ah-deh-oosh",
      en: "Goodbye",
    },
    {
      pt: "Tchau",
      rm: "Chow",
      en: "Bye (informal)",
    },
    {
      pt: "Até logo",
      rm: "Ah-teh loh-go",
      en: "See you later",
    },
    {
      pt: "Por favor",
      rm: "Por fa-vor",
      en: "Please",
    },
    {
      pt: "Obrigado/Obrigada",
      rm: "O-bree-gah-doo (m) / O-bree-gah-dah (f)",
      en: "Thank you (male/female)",
    },
    {
      pt: "Muito obrigado/obrigada",
      rm: "Mween-too o-bree-gah-doo (m) / Mween-too o-bree-gah-dah (f)",
      en: "Thank you very much (male/female)",
    },
    {
      pt: "De nada",
      rm: "Deh nah-dah",
      en: "You're welcome",
    },
    {
      pt: "Com licença",
      rm: "Con lee-sen-sah",
      en: "Excuse me",
    },
    {
      pt: "Desculpe",
      rm: "Desh-cool-peh",
      en: "Sorry",
    },
    {
      pt: "Sim",
      rm: "Seen",
      en: "Yes",
    },
    {
      pt: "Não",
      rm: "Now",
      en: "No",
    },
    {
      pt: "Tudo bem",
      rm: "Too-doo bem",
      en: "Okay / Alright / Everything is fine",
    },
    {
      pt: "Eu não entendo",
      rm: "Eh-oo now en-ten-doo",
      en: "I don't understand",
    },
    {
      pt: "Você fala inglês?",
      rm: "Vo-seh fa-lah een-gles?",
      en: "Do you speak English? (formal - Brazil)",
    },
    {
      pt: "Fala inglês?",
      rm: "Fa-lah een-gles?",
      en: "Do you speak English? (informal - Brazil)",
    },
    {
      pt: "Fala inglês?",
      rm: "Fa-lah een-glesh?",
      en: "Do you speak English? (Portugal)",
    },
    {
      pt: "Como está?",
      rm: "Ko-mo esh-tah?",
      en: "How are you? (formal)",
    },
    {
      pt: "Como você está?",
      rm: "Ko-mo vo-seh esh-tah?",
      en: "How are you? (Brazil, formal)",
    },
    {
      pt: "Como estás?",
      rm: "Ko-mo esh-tash?",
      en: "How are you? (Portugal, informal)",
    },
    {
      pt: "Tudo bem?",
      rm: "Too-doo bem?",
      en: "Is everything okay? / How's it going?",
    },
    {
      pt: "Bem, obrigado/obrigada",
      rm: "Bem, o-bree-gah-doo (m) / o-bree-gah-dah (f)",
      en: "Fine, thank you (male/female)",
    },
    {
      pt: "Qual é o seu nome?",
      rm: "Kwal eh oo seh-oo no-meh?",
      en: "What is your name? (formal)",
    },
    {
      pt: "Qual é o seu nome?",
      rm: "Kwal eh oo teu no-meh?",
      en: "What is your name? (informal)",
    },
    {
      pt: "Meu nome é...",
      rm: "Meh-oo no-meh eh...",
      en: "My name is...",
    },
    {
      pt: "Onde é...?",
      rm: "On-deh eh...?",
      en: "Where is...?",
    },
    {
      pt: "Onde é a casa de banho?",
      rm: "On-deh eh ah kah-zah deh ban-yoo?",
      en: "Where is the bathroom? (Portugal)",
    },
    {
      pt: "Onde é o banheiro?",
      rm: "On-deh eh oo ban-yay-roo?",
      en: "Where is the bathroom? (Brazil)",
    },
    {
      pt: "Onde é a estação de comboios?",
      rm: "On-deh eh ah es-tah-sow deh com-boy-oosh?",
      en: "Where is the train station? (Portugal)",
    },
    {
      pt: "Onde é a estação de trem?",
      rm: "On-deh eh ah es-tah-sow deh trem?",
      en: "Where is the train station? (Brazil)",
    },
    {
      pt: "Onde é o aeroporto?",
      rm: "On-deh eh oo a-eh-ro-por-too?",
      en: "Where is the airport?",
    },
    {
      pt: "Quanto custa?",
      rm: "Kwan-too koosh-tah?",
      en: "How much does it cost?",
    },
    {
      pt: "É muito caro",
      rm: "Eh mween-too kah-roo",
      en: "It's very expensive",
    },
    {
      pt: "Socorro!",
      rm: "So-ko-rroo!",
      en: "Help!",
    },
    {
      pt: "Ajuda!",
      rm: "Ah-zhoo-dah!",
      en: "Help!",
    },
    {
      pt: "Preciso de ajuda",
      rm: "Preh-see-zoo deh ah-zhoo-dah",
      en: "I need help",
    },
    {
      pt: "Estou perdido/a",
      rm: "Esh-toy per-dee-doo (m) / Esh-toy per-dee-dah (f)",
      en: "I am lost (male/female)",
    },
    {
      pt: "Estou à procura de...",
      rm: "Esh-toy ah pro-koo-rah deh...",
      en: "I'm looking for...",
    },
    {
      pt: "Queria...",
      rm: "Keh-ree-ah...",
      en: "I would like...",
    },
    {
      pt: "Quero...",
      rm: "Keh-roo...",
      en: "I want...",
    },
    {
      pt: "Um café, por favor",
      rm: "Oon kah-feh, por fa-vor",
      en: "A coffee, please",
    },
    {
      pt: "A conta, por favor",
      rm: "Ah kon-tah, por fa-vor",
      en: "The bill, please",
    },
    {
      pt: "Eu sou vegetariano/a",
      rm: "Eh-oo sow veh-jeh-tah-ree-ah-no (m) / veh-jeh-tah-ree-ah-nah (f)",
      en: "I am vegetarian (male/female)",
    },
    {
      pt: "Sou alérgico/a a...",
      rm: "Sow ah-ler-zhee-ko (m) / ah-ler-zhee-kah (f) ah...",
      en: "I am allergic to...",
    },
    {
      pt: "É delicioso",
      rm: "Eh deh-lee-see-o-zoo",
      en: "It's delicious",
    },
    {
      pt: "Saúde!",
      rm: "Sah-oo-deh!",
      en: "Cheers!",
    },
    {
      pt: "Não me sinto bem",
      rm: "Now meh seen-too bem",
      en: "I don't feel well",
    },
    {
      pt: "Onde é o hospital?",
      rm: "On-deh eh oo os-pee-tal?",
      en: "Where is the hospital?",
    },
    {
      pt: "Falo um pouco de português",
      rm: "Fa-loo oon po-ko deh por-too-ges",
      en: "I speak a little Portuguese",
    },
    {
      pt: "Mais devagar, por favor",
      rm: "Mais deh-vah-gar, por fa-vor",
      en: "Slower, please",
    },
    {
      pt: "Pode repetir, por favor?",
      rm: "Po-deh reh-peh-teer, por fa-vor?",
      en: "Can you repeat that, please?",
    },
    {
      pt: "Estou cansado/a",
      rm: "Esh-toy kan-sah-doo (m) / kan-sah-dah (f)",
      en: "I am tired (male/female)",
    },
    {
      pt: "Qual é o tempo?",
      rm: "Kwal eh oo tem-po?",
      en: "What's the weather like?",
    },
    {
      pt: "Está bom tempo",
      rm: "Esh-tah bom tem-po",
      en: "The weather is good",
    },
    {
      pt: "Está calor",
      rm: "Esh-tah kah-lor",
      en: "It's hot",
    },
    {
      pt: "Está frio",
      rm: "Esh-tah free-oo",
      en: "It's cold",
    },
    {
      pt: "Está a chover",
      rm: "Esh-tah ah shoo-ver",
      en: "It's raining",
    },
    {
      pt: "De acordo",
      rm: "Deh ah-kor-doo",
      en: "Agreed / Okay",
    },
    {
      pt: "Não concordo",
      rm: "Now kon-kor-doo",
      en: "I disagree",
    },
    {
      pt: "É interessante",
      rm: "Eh een-teh-re-san-teh",
      en: "It's interesting",
    },
    {
      pt: "É importante",
      rm: "Eh eem-por-tan-teh",
      en: "It's important",
    },
    {
      pt: "É possível",
      rm: "Eh poo-see-vel",
      en: "It's possible",
    },
    {
      pt: "É impossível",
      rm: "Eh eem-poo-see-vel",
      en: "It's impossible",
    },
    {
      pt: "Que horas são?",
      rm: "Keh o-rash sow?",
      en: "What time is it?",
    },
    {
      pt: "Hoje",
      rm: "Oy-jeh",
      en: "Today",
    },
    {
      pt: "Amanhã",
      rm: "Ah-man-yah",
      en: "Tomorrow",
    },
    {
      pt: "Ontem",
      rm: "On-ten",
      en: "Yesterday",
    },
    {
      pt: "Agora",
      rm: "Ah-go-rah",
      en: "Now",
    },
    {
      pt: "Mais tarde",
      rm: "Mais tar-deh",
      en: "Later",
    },
    {
      pt: "À direita",
      rm: "Ah dee-rai-tah",
      en: "To the right",
    },
    {
      pt: "À esquerda",
      rm: "Ah eesh-ker-dah",
      en: "To the left",
    },
    {
      pt: "Em frente",
      rm: "Em fren-teh",
      en: "Straight ahead",
    },
    {
      pt: "Perto",
      rm: "Peh-rtoo",
      en: "Near",
    },
    {
      pt: "Longe",
      rm: "Lon-jeh",
      en: "Far",
    },
    {
      pt: "Estou perdido/a",
      rm: "Esh-toy per-dee-doo (m) / per-dee-dah (f)",
      en: "I'm lost (male/female)",
    },
    {
      pt: "Estou doente",
      rm: "Esh-toy doo-en-teh",
      en: "I am sick",
    },
    {
      pt: "É urgente",
      rm: "Eh oor-zhen-teh",
      en: "It's urgent",
    },
    {
      pt: "Um momento, por favor",
      rm: "Oon mo-men-too, por fa-vor",
      en: "One moment, please",
    },
    {
      pt: "Não sei",
      rm: "Now say",
      en: "I don't know",
    },
    {
      pt: "Está tudo bem",
      rm: "Esh-tah too-doo bem",
      en: "Everything is okay",
    },
    {
      pt: "Não faz mal",
      rm: "Now faz mal",
      en: "It doesn't matter / Never mind",
    },
    {
      pt: "Sem problemas",
      rm: "Sem pro-bleh-mash",
      en: "No problem",
    },
    {
      pt: "Cuidado!",
      rm: "Kwee-dah-doo!",
      en: "Be careful!",
    },
    {
      pt: "Deixe-me em paz",
      rm: "Deh-sheh-meh em pahz",
      en: "Leave me alone",
    },
    {
      pt: "Estou com fome",
      rm: "Esh-toy kon fo-meh",
      en: "I'm hungry",
    },
    {
      pt: "Estou com sede",
      rm: "Esh-toy kon seh-deh",
      en: "I'm thirsty",
    },
    {
      pt: "Sinto muito",
      rm: "Seen-too mween-too",
      en: "I'm very sorry",
    },
    {
      pt: "Parabéns!",
      rm: "Pah-rah-bains!",
      en: "Congratulations!",
    },
    {
      pt: "Boa sorte!",
      rm: "Boa sor-teh!",
      en: "Good luck!",
    },
    {
      pt: "Boa viagem!",
      rm: "Boa vee-ah-zhen!",
      en: "Have a good trip!",
    },
    {
      pt: "À sua saúde!",
      rm: "Ah soo-ah sah-oo-deh!",
      en: "To your health! (Cheers)",
    },
    {
      pt: "É grátis?",
      rm: "Eh grah-tees?",
      en: "Is it free?",
    },
    {
      pt: "Qual é a senha do Wi-Fi?",
      rm: "Kwal eh ah sen-yah doo Wi-Fi?",
      en: "What is the Wi-Fi password?",
    },
    {
      pt: "Posso tirar uma foto?",
      rm: "Po-soo chee-rar oo-mah fo-too?",
      en: "Can I take a picture?",
    },
  ],
};
